import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'apli';
const args = {};

export class Apli extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
